<h1 class="title">Building</h1>
<h5>Manage Building Information</h5>
<div class="cas-wrapper">
    <acabim-bim-visualiser-location-selector
            [basicLocation]="true"
            (locationEmitter)="selectLocation($event)"
            [cardTitle]="'Location & Building'"
            [collapsed]="true"
    ></acabim-bim-visualiser-location-selector>

    <p-tabView *ngIf="selectedProject && selectedProject.buildingGuid" orientation="right"
               (onChange)="selectTab($event)" [activeIndex]="index">

        <p-tabPanel header="Manage Details">
            <ng-template pTemplate="content">
                <div class="cas-flex-row">
                    <div class="col-md-12">
                        <acabim-card [cardContent]="form" cardHeading="Details"></acabim-card>
                    </div>
                    <div class="col-md-12">
                        <acabim-card [cardContent]="table" cardHeading="Functional Properties"></acabim-card>
                    </div>
                    <div class="col-md-7" style="margin-right: -0.5rem!important;">
                        <acabim-card [cardContent]="attachment" cardHeading="Attachments"></acabim-card>
                    </div>
                    <div class="col-md-5" style="margin-left: 0.5rem!important;">
                        <acabim-card [cardContent]="metadata" cardHeading="Metadata"></acabim-card>
                    </div>
                </div>
            </ng-template>
        </p-tabPanel>

        <p-tabPanel header="Manage Financial">
            <ng-template pTemplate="content">
                <acabim-admin-building-financial-management [selectedProject]="selectedProject"></acabim-admin-building-financial-management>
            </ng-template>
        </p-tabPanel>

    </p-tabView>
</div>

<ng-template #form>
    <form [formGroup]="editForm" class="cas-flex-row cas-form-flat cas-form-label-align-right">
        <acabim-form-block labelWidth="10" [labelAlign]="'right'" [colonize]="true" class="col-md-6">
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Number</acabim-form-input-label>
                <acabim-form-input-content [shortField]="true">
                    <input formControlName="buildingNumber" type="number">
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Name</acabim-form-input-label>
                <acabim-form-input-content [shortField]="true">
                    <input formControlName="buildingName" type="text">
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Long name</acabim-form-input-label>
                <acabim-form-input-content>
                    <input formControlName="buildingLongName" type="text">
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Description</acabim-form-input-label>
                <acabim-form-input-content>
                    <input formControlName="buildingDescription">
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Function</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-dropdown
                        #functionDropdown
                        appendTo="body"
                        formControlName="function"
                        [options]="functions"
                        optionLabel="name"
                        placeholder="Select Type"
                        [filter]="true"
                        scrollHeight="300px"
                        (onChange)="addFunction()"
                    >
                    </p-dropdown>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Construction Start Date</acabim-form-input-label>
                <acabim-form-input-content>
                    {{selectedProject.constructionStartDate | date:'dd/MM/yyyy'}}
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Phase</acabim-form-input-label>
                <acabim-form-input-content [shortField]="true">
                    {{selectedProject.currentPhase}}
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
        </acabim-form-block>

        <acabim-form-block labelWidth="10" [labelAlign]="'right'" [colonize]="true" [shortFields]="false" class="col-md-6">
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Storeys count</acabim-form-input-label>
                <acabim-form-input-content [shortField]="true">
                    {{currentStoreyData.length}}
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Total GFA</acabim-form-input-label>
                <acabim-form-input-content [shortField]="true">
                    <div>
                        {{floorArea.toFixed(2)}}
                        <span class="cas-form-units">m²</span>
                    </div>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Height</acabim-form-input-label>
                <acabim-form-input-content [shortField]="true">
                    <div>
                        {{height.toFixed(2)}}
                        <span class="cas-form-units">m</span>
                    </div>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Elevation</acabim-form-input-label>
                <acabim-form-input-content [shortField]="true">
                    <div>
                        <input formControlName="elevation">
                        <span class="cas-form-units">m</span>
                    </div>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Remarks</acabim-form-input-label>
                <acabim-form-input-content>
                    <input formControlName="remarks">
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Practical Completion Date</acabim-form-input-label>
                <acabim-form-input-content [shortField]="true">
                    {{selectedProject.practicalCompletionDate  | date:'dd/MM/yyyy'}}
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
        </acabim-form-block>

        <div class="cas-action-buttons col-md-12">
            <button class="cas-button-action" (click)="onSubmit()">Update</button>
        </div>
    </form>
</ng-template>

<ng-template #metadata>
    <acabim-form-block labelWidth="10" [labelAlign]="'right'" [colonize]="true" class="col-md-12">
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Site</acabim-form-input-label>
            <acabim-form-input-content>
                {{selectedSite ? selectedSite.id : ''}}
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Project</acabim-form-input-label>
            <acabim-form-input-content>
                {{selectedProject ? selectedProject.id ? selectedProject.id : '' : ''}}
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Building</acabim-form-input-label>
            <acabim-form-input-content>
                {{selectedProject ? selectedProject.buildingGuid ? selectedProject.buildingGuid : '' : ''}}
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Last Updated</acabim-form-input-label>
            <acabim-form-input-content>
                {{currentBuilding ? currentBuilding.lastUpdatedDate : ''}}
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Updated By</acabim-form-input-label>
            <acabim-form-input-content>
                {{currentBuilding ? currentBuilding.lastUpdatedUser ? currentBuilding.lastUpdatedUser.name : '' : ''}}
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
    </acabim-form-block>
</ng-template>

<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>

<ng-template #table>
    <div class="cas-pad" style="margin-bottom: -2rem;">
        <acabim-datatable #datatable [dataSources]="dataSources"></acabim-datatable>
        <div class="cas-action-buttons" style="margin-top: -5rem;">
            <button class="cas-button-action" style="margin-top: -5rem;" (click)="addModal = true">Add</button>
        </div>
    </div>
</ng-template>

<ng-template #attachment>
    <div class="cas-pad">
        <acabim-multifile-upload #fileComp
                                 [mimeTypes]="mimetypes"
                                 (fileAdded)="onFileAdded($event)"
                                 (fileDeleted)="onFileDeleted($event)"
                                 (fileLoading)="onFileLoading($event)"
                                 [fullFiles]="fullFiles" [hasDelete]="true"
        ></acabim-multifile-upload>
        <div class="cas-action-buttons">
            <button class="cas-button-action ml-0" type="button" (click)="addToBuilding()" [disabled]="disableAdd">Add
            </button>
        </div>
    </div>
</ng-template>

<acabim-modal [title]="'Add Functional Property'" [display]="addModal" (status)="setAddStatus($event)" width="50rem">
    <acabim-admin-add-functional-properties
            [buildingGUID]="selectedProject ? selectedProject.buildingGuid ? selectedProject.buildingGuid : '' : ''"
            (addFunction)="closeAdd()"></acabim-admin-add-functional-properties>
</acabim-modal>

<acabim-modal [title]="' '" [display]="deleteModal" (status)="setDeleteStatus($event)" height="30vh">
    <acabim-admin-delete-functional-properties (deleteResult)="closeDeleteModal()"
                                               [functions]="selectedFuncs"></acabim-admin-delete-functional-properties>
</acabim-modal>

<p-toast position="center"></p-toast>

<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" key="confirmAttachment"
                 acceptButtonStyleClass="cas-button-action"></p-confirmDialog>

